export enum ENavigationRoute {

  DescriptionStation = 'description-station',
  IBD = 'ibd',
  IBGN = 'ibgn',
  MPCE = 'mpce',
  EAU = 'eau',
  LAC = 'lac',
  IBMR = 'ibmr',
  MGCE = 'mgce',
  IML = 'iml',
  InterventionList = 'intervention-list',
  InterventionDashboard = 'intervention',
  PlanPrelevement = 'plan-prelevement',
  Analyse = 'analyse',
  AnalyseIBMR = 'analyse-ibmr',
  AnalyseCyano = 'analyse-cyano',
  AnalyseList = 'analyse-list',
  Photo = 'photo',
  PhotoViewer = 'take-photo',
  Documents = 'documents',
  Notation = 'notation',
  DocumentViewer = 'local-picture',
  Metrologie = 'metrologie',
  Exports = 'exports',
  Logistique = 'logistique',
  SamplingPointMap = 'carte',
  Error = 'error',
  Admin = 'admin'
}
